import setDestinationMiddlewares from './destinationMiddlewares/index.js'
import setSourceMiddlewares from './sourceMiddlewares/index.js'

let setMiddlewares = () => {
  const analytics = window.analytics

  if (analytics) {
    setSourceMiddlewares()
    setDestinationMiddlewares()
  }

  // Avoid to set middlewares more than once.
  setMiddlewares = () => {}
}

export default setMiddlewares
